import { Component } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { SaveForm } from '@tokeet-frontend/tv3-platform'
import { select, Store } from '@ngrx/store'
import { UtilityService } from '@tv3/services/utils/utility.service'
import { Toaster } from '@tokeet-frontend/tv3-platform'
import { AddForwards } from '@tv3/store/forward/forward.actions'
import { ForwardForm } from '@tv3/interfaces/forms/forward.form'
import { emailOrUrlValidator } from '@tokeet-frontend/tv3-platform'
import { selectAllRentals } from '@tokeet-frontend/tv3-platform'
import { observeOn } from 'rxjs/operators'
import { asyncScheduler } from 'rxjs'
import { AmplitudeService } from '@tv3/services/amplitude.service'

@Component({
  selector: 'app-add-forward-dialog',
  templateUrl: './add-forward-dialog.component.html',
  host: { class: 'modal-content' },
  styleUrls: ['./add-forward-dialog.component.scss'],
})
export class AddForwardDialogComponent {
  rentals$ = this.store.pipe(observeOn(asyncScheduler), select(selectAllRentals))

  form = this.fb.group({
    forward: ['', [Validators.required, emailOrUrlValidator]],
    rentals: [[], [Validators.required]],
  })

  constructor(
    public dialogRef: MatDialogRef<AddForwardDialogComponent>,
    private store: Store<any>,
    private toast: Toaster,
    private utility: UtilityService,
    private fb: FormBuilder,
    private amplitudeService: AmplitudeService
  ) {}

  get forwardField() {
    return this.form.get('forward')
  }

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  create(form: FormGroup) {
    this.amplitudeService.logEvent('add-email-forwarding')
    const values = form.getRawValue() as ForwardForm
    this.store.dispatch(AddForwards({ form: values }))
    this.close()
  }
}
